import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { Skeleton } from '@material-ui/lab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { TableLoader } from 'components/Loaders/TableLoader';

const GroupsLoader = () => {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h6" style={{ margin: '20px 0' }}>
        <Skeleton animation="wave" variant="text" width="25%" />
      </Typography>
      <TableContainer component={Paper} elevation={3} style={{ height: '55vh' }}>
        <Table aria-label="order list">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '5%' }}>
                <Checkbox disabled />
              </TableCell>
              <TableCell align="center" style={{ width: '35%' }}>
                {t('label.serial number')}
              </TableCell>
              <TableCell align="center" style={{ width: '10%' }}>
                {t('label.issue date')}
              </TableCell>
              <TableCell align="center" style={{ width: '35%' }}>
                {t('products.third party serial number')}
              </TableCell>
              <TableCell align="center" style={{ width: '15%' }} />
            </TableRow>
          </TableHead>
          <TableBody>
            <TableLoader colSpan={5} />
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export { GroupsLoader };
